import React, { Component } from 'react';
import Swal from 'sweetalert2';
import { getUrlId, RedirectToUrlDirect } from '../Utils/responseHandler';
import apiClient from '../Utils/apiClient';
import MainCompanyController from '../Controllers/MainCompanyController';
import CompanySelect from '../Components/CompanySelect';
import { toastSuccess, toastError } from '../Utils/toast';
const _ = require('lodash');

export class EditCompany extends Component {

    constructor(props) {
        super(props)
        this.scopedMainCompanyId = localStorage.getItem('userRole') === 'Admin'
            ? (localStorage.getItem('mainCompanyId') || '')
            : '';
        this.state = {
            data: {},
            title: "Extra Fields",
            formValues: [{
                name_firma: "", owner_name: "", short_name: "", status: "", phone: "", production: "", loginmethod: "", main_company_id: ""
            }],
            extraValues: [],
            label: "",
            messageError: "",
            messageSuccess: "",
            company_fields: [],
            mainCompanies: [],
            isLoading: true,
            regeneratingClientId: false,
            regeneratingApiKey: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    regenerateClientId = async () => {
        const result = await Swal.fire({
            title: 'Regenerate Client ID?',
            text: 'The old Client ID will stop working immediately. Any integration using it will need to be updated.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Regenerate',
            confirmButtonColor: '#ef4444',
        });
        if (!result.isConfirmed) return;
        this.setState({ regeneratingClientId: true });
        try {
            const res = await apiClient.post('companies/' + getUrlId() + '/regenerate-client-id');
            this.setState((prev) => ({ data: { ...prev.data, client_id: res.data.data.client_id } }));
            toastSuccess('Client ID regenerated');
        } catch (err) {
            toastError(err.response?.data?.message || 'Failed to regenerate Client ID');
        } finally {
            this.setState({ regeneratingClientId: false });
        }
    }

    regenerateApiKey = async () => {
        const result = await Swal.fire({
            title: 'Regenerate API key?',
            text: 'The old API key will stop working immediately. Any integration using it will need to be updated.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Regenerate',
            confirmButtonColor: '#ef4444',
        });
        if (!result.isConfirmed) return;
        this.setState({ regeneratingApiKey: true });
        try {
            const res = await apiClient.post('companies/' + getUrlId() + '/regenerate-apikey');
            this.setState((prev) => ({ data: { ...prev.data, apikey: res.data.data.apikey } }));
            toastSuccess('API key regenerated');
        } catch (err) {
            toastError(err.response?.data?.message || 'Failed to regenerate API key');
        } finally {
            this.setState({ regeneratingApiKey: false });
        }
    }

    mainChange(i, e) {
        let formValues = this.state.formValues;
        formValues[0][e.target.name] = e.target.value;
        this.state.data[e.target.name] = e.target.value;
        this.setState({ formValues: formValues });
    }
    handleCompanyValueChange(i, e) {
        let company_fields = this.state.company_fields;
        if (company_fields[i].id) {
            company_fields[i].value = e.target.value;

        } else {
            company_fields[i]['value'] = e.target.value;
        }
        this.setState({ company_fields });
    }
    handleCompanyNameChange(i, e) {
        let company_fields = this.state.company_fields;
        if (company_fields[i].id) {
            company_fields[i].name = e.target.value;

        } else {
            company_fields[i]['name'] = e.target.value;
        }
        this.setState({ company_fields });
    }

    addFormFields() {
        this.setState(({
            company_fields: [...this.state.company_fields, {}]
        }))
    }

    async removeFormFields(i, el) {
        if (!_.isEmpty(el[i])) {
            let res = await
                apiClient.delete('companies/fields/' + el[i].id)
                    .then(response => { console.log(response) })
                    .catch(error => {
                        console.error('Error fetching data:', error);
                    });
        }
        let company_fields = this.state.company_fields;
        company_fields.splice(i, 1);
        this.setState({ company_fields });
    }

    async handleSubmit(e) {
        e.preventDefault();
        let output = [];
        let mainvalue = this.state.formValues[0];
        let extvalue = this.state.company_fields;
        mainvalue['company_fields'] = extvalue;
        try {

            let res = await apiClient.put('companies/' + getUrlId(), mainvalue);
            let resJson = res.data;
            console.log(resJson);
            if (resJson.error === false) {
                if(resJson.data) {
                    var errorObj = []
                    resJson.data.forEach(element => {
                        errorObj[element.field] = (errorObj[element.field])? errorObj[element.field] + ', ' + element.message: element.message
                    });
                    this.setState({ messageError: errorObj});
                } else {
                    this.setState({ messageError: resJson.data});
                }
                toastError('Failed to update company');
            }
            if (resJson && resJson.success) {
                this.setState({ messageError: "Company has been updated !!" });
                toastSuccess('Company updated');
                window.location.replace('/companies');
            }
        } catch (err) {
            console.log(err);
            this.setState({ messageError: "Some error occured" });
            toastError(err.response?.data?.message || 'Some error occurred');
        }
    }

    async fetchData() {
        const id = getUrlId();
        console.log(id);
        try {
            apiClient.get('companies/' + id)
                .then(response => response.data)
                .then(res => {
                    console.log(res.data)
                    this.setState({
                        data: res.data,
                        formValues: [{
                            name_firma: res.data.name_firma,
                            phone: res.data.phone,
                            owner_name: res.data.owner_name,
                            short_name: res.data.short_name,
                            status: res.data.status,
                            production: res.data.production,
                            main_company_id: res.data.main_company_id || '',
                        }],
                        company_fields: res.data.company_fields,
                        isLoading: false,
                    });
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            this.setState({ isLoading: false });
        }
    }
    componentDidMount() {
        this.fetchData();
        MainCompanyController.list()
            .then((mainCompanies) => this.setState({ mainCompanies: mainCompanies || [] }))
            .catch((err) => console.error('Failed to load main companies', err));
    }

    render() {
        const { name_firma, owner_name, short_name, status, phone, production, loginmethod, extra_fields } = this.state.formValues[0];
        const { data, company_fields, formValues, isLoading } = this.state;

        return (
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className='card'>
                        <div className='modal-header'>
                            <h6>Edit Company</h6>
                        </div>
                        <div className='card-body registration_form'>
                            <form onSubmit={this.handleSubmit} >
                                <div className="modal-body">
                                    <div className='row' >
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Company Name</label>
                                                <input type="text" className="form-control" name="name_firma"
                                                    value={data.name_firma}
                                                    onChange={e => this.mainChange(formValues.name_firma, e)} />
                                                    {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['name_firma']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Owner Name</label>
                                                <input type="text" className="form-control" name="owner_name"
                                                    value={data.owner_name}
                                                    onChange={e => this.mainChange(formValues.owner_name, e)} />
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['owner_name']}</span>}

                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Phone</label>
                                                <input type="text" className="form-control" name="phone"
                                                    value={data.phone}
                                                    onChange={e => this.mainChange(formValues.phone, e)} />
                                                    {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['phone']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Short Name</label>
                                                <input type="text" className="form-control" disabled name="short_name" value={data.short_name}
                                                    onChange={e => this.mainChange(formValues.short_name, e)} />
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Status</label>
                                                <select className="form-select form-control" name="status"
                                                    onChange={e => this.mainChange(formValues.status, e)}
                                                    value={data.status}>
                                                    <option value="true">Active</option>
                                                    <option value="false">In Active</option>
                                                </select>
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['status']}</span>}

                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Production Mode</label>
                                                <select className="form-select form-control" name="production"
                                                    onChange={e => this.mainChange(formValues.production, e)}
                                                    value={data.production}>
                                                    <option value="live">Live</option>
                                                    <option value="test">Test</option>
                                                </select>
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['production']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Client ID</label>
                                                <div style={{ display: 'flex', gap: 8 }}>
                                                    <input type="text" className="form-control" disabled value={data.client_id || ''} />
                                                    {(
                                                        (localStorage.getItem('userRole') === 'SuperAdmin') && 
                                                    <button type="button" className="btn btn-light" disabled={this.state.regeneratingClientId}
                                                        onClick={this.regenerateClientId}>
                                                        <i className="bi bi-arrow-repeat"></i> {this.state.regeneratingClientId ? '...' : 'Regenerate'}
                                                    </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Api key</label>
                                                <div style={{ display: 'flex', gap: 8 }}>
                                                    <input type="text" className="form-control" disabled value={data.apikey || ''} />
                                                    {(
                                                        (localStorage.getItem('userRole') === 'SuperAdmin') && 
                                                        <button type="button" className="btn btn-light" disabled={this.state.regeneratingApiKey} onClick={this.regenerateApiKey}>
                                                        <i className="bi bi-arrow-repeat"></i> {this.state.regeneratingApiKey ? '...' : 'Regenerate'}
                                                    </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Login Method</label>
                                                <select className="form-select form-control" name="loginmethod"
                                                    onChange={e => this.mainChange(formValues.loginmethod, e)}
                                                    value={data.loginmethod}>                                                    
                                                    <option value="code">Email(pincode)</option>
                                                    <option value="url">Email(redirecturl)</option>
                                                    <option value="sms">SMS</option>
                                                </select>
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['loginmethod']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Main Company</label>
                                                <CompanySelect
                                                    companies={this.state.mainCompanies}
                                                    value={data.main_company_id || ''}
                                                    onChange={(id) => this.mainChange(formValues.main_company_id, { target: { name: 'main_company_id', value: id } })}
                                                    placeholder="— None —"
                                                    disabled={!!this.scopedMainCompanyId}
                                                    variant="field"
                                                />
                                                {this.scopedMainCompanyId && <p className="text-muted" style={{ marginBottom: 0 }}>Locked to your assigned main company.</p>}
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['main_company_id']}</span>}
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.title ? <h4 className='text-left'>{this.state.title}</h4> : null}
                                    {company_fields.map((item, index) => (
                                        <div className='row form-group' key={index}>
                                            <div className={index ? 'col-lg-5' : 'col-lg-6'}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name='name'
                                                    value={(item.name) ?? ''}
                                                    onChange={(e) => this.handleCompanyNameChange(index, e)}
                                                />
                                            </div>
                                            <div className='col-lg-6'>
                                                {
                                                    (item.type == 'textarea') ?
                                                        <textarea type={(item.type) ? item.type : "text"}
                                                            className="form-control"
                                                            name='value'
                                                            value={item.value ?? ''}
                                                            onChange={(e) => this.handleCompanyValueChange(index, e)}
                                                        ></textarea>
                                                        :
                                                        <input
                                                            type={(item.type) ? item.type : "text"}
                                                            className="form-control"
                                                            name='value'
                                                            value={item.value}
                                                            onChange={(e) => this.handleCompanyValueChange(index, e)}
                                                        />
                                                }
                                            </div>
                                            {
                                                index ?
                                                    <div className='col-lg-1'>
                                                        <button type="button" className="btn btn-icon btn-rounded btn-warning remove float-right remove" onClick={() => this.removeFormFields(index, company_fields)}><i className='bi bi-trash-fill'></i></button>
                                                    </div>
                                                    : <div className='col-lg-1'></div>
                                            }
                                        </div>
                                    ))
                                    }
                                    <button className="btn btn-primary btn-icon btn-rounded float-right" type="button" onClick={() => this.addFormFields()}><i className='bi bi-plus'></i></button>
                                    <div className='clearfix'></div>
                                </div>

                                <div className="modal-footer">
                                    <button className="btn btn-primary float-left" type="submit">Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
